import request from 'superagent';
import { readable } from 'svelte/store';

function makeTree(list) {
  var map = {}, node, roots = [], i;
  for (i = 0; i < list.length; i++) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
  }
  for (i = 0; i < list.length; i++) {
      node = list[i];
      if (node.parent_id && node.parent_id !== null) {
        // if you have dangling branches check that map[node.parentId] exists
        try {
          list[map[node.parent_id]].children.push(node);
        } catch {
          console.log("Node push fail.", node, roots, map);
        }
        //node['parent'] = list[map[node.parent_id]];
      } else {
        roots.push(node);
      }
  }
  return roots;
}



export const categories = readable([], set => {
  var ttl = 300;

  function get() {
    request.get('/ix/c.jsr')
    .then(function(r) {
      if (r.ok) return r;
      if (r.code != 401) throw Error(r.statusText);
    })
    .then(resp => {
      var categories = makeTree(resp.body.data);
      localStorage.setItem('categories', JSON.stringify({data: resp.body.data, t: parseInt(Date.now() / 1000)}));
      set(categories);
    })
    .catch(resp => {
      console.log(JSON.stringify(resp))
    })
  }
  setTimeout(get, 12*60);

   //get cached data from local storage
  var cache = localStorage.getItem('categories');
  if(cache){
    cache = JSON.parse(cache);
    var expired = parseInt(Date.now() / 1000) - cache.t > ttl;
    if (!expired) {
      var categories = makeTree(cache.data)
      set(categories);
      return categories;
    }
  }
  get();
});


export const topics = readable([], set => {
  var ttl = 300;

  function get() {
    request.get('/p/news/topics.jsr')
    .then(function(r) {
      if (r.ok) return r;
      if (r.code != 401) throw Error(r.statusText);
    })
    .then(resp => {
      var topics = makeTree(resp.body.data);

      localStorage.setItem('topics', JSON.stringify({data: resp.body.data, t: parseInt(Date.now() / 1000)}));
      set(topics);
    })
    .catch(resp => {
      console.log(JSON.stringify(resp))
    })
  }
  setTimeout(get, 12*60);

   //get cached data from local storage
  var cache = localStorage.getItem('topics');
  if(cache){
    cache = JSON.parse(cache);
    var expired = parseInt(Date.now() / 1000) - cache.t > ttl;
    if (!expired) {
      var topics = makeTree(cache.data)
      set(topics);
      return topics;
    }
  }
  get();

});

export const my_topics = readable([], set => {
  function get() {
    request.get('/my/feeds/topics.json')
    .then(function(r) {
      if (r.ok) return r.body.count == 1 ? [r.body.data] : r.body.data || [];
      if (r.code != 401) throw Error(r.statusText);
    })
    .then(data => {
      set(makeTree(data));
    })
  }
  setTimeout(get, 12*60);
  get();
});

/*export const nlp_datasets = readable([], set => {
  setTimeout(() => {
    request.get('/l/datasets.jsr')
    .then(function(r) {
      if (r.ok) return r;
      if (r.code != 401) throw Error(r.statusText);
    })
    .then(resp => {
      set(resp.body.data);
    })
    .catch(resp => {
      console.log(JSON.stringify(resp))
    })
  }, 12*60)
});*/


